import http from './http'

const api = {
  /**
   * 获取资讯详情
   * @param newsId 资讯id
   */
  getNewsInfo (newsId) {
    const params = {newsId}
    return http.post('/api/e-circle/news/newsInfo', params)
  },
  /**
   * 统计 cbType:
   * APP_CLICK: app点击
   * REC_CLICK:推荐点击
   * @param newsId
   * @param cbType
   */
  optCallBack (newsId, cbType) {
    const params = {newsId, cbType}
    return http.post('/api/e-circle/opt/callBack', params)
  },
  getArticleInfo (articleId) {
    // todo 写死的用户id,需要真实的id或者让后台移除此id校验,或者再给个接口地址
    return http.post('/api/e-circle/group/articleInfo', {articleId, uid: 14012})
  },

  dailyRecommendInfo (id) {
    return http.post('/api/cc-kz/opt/dailyRecommendInfo', {id})
  },

  getArticleRecommend (id) {
    return http.post('/api/e-circle/news/newRecommend', {dataSize: 30, targetId: id})
  },
  // 获取视频的数据
  getVideoInfo (dataId) {
    return http.post('/api/e-circle/category/getDataVideoInfo', {dataId:dataId})
  },

  /**
   * 参考地址:https://blog.csdn.net/hjhfreshman/article/details/90052690
   * 获取微信的信息
   * timestamp:必填，生成签名的时间戳
   * nonceStr:必填，生成签名的随机串
   * signature:必填，签名，见附录1
   */
  getWxInfo (url) {
    return http.post('/api/e-circle/wx/getSign', {url})
  },

  signIn(params){
    return http.post("/api/e-circle/auth/user/vz/singIn",params)
  }
}
export default api



// WEBPACK FOOTER //
// ./src/utils/api.js